var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.country)?_c('CountryFlag',{attrs:{"rounded":"","country":_vm.country,"size":_vm.size}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }